export default "__VITE_ASSET__D_1Q$zqa__"